import React, { useState } from 'react'
import SidebarMobile from '../navigation/SidebarMobile'
import SidebarDesktop from '../navigation/SidebarDesktop'
import SidebarTablet from '../navigation/SidebarTablet'
import SidebarOpenButton from '../navigation/SidebarOpenButton'
import WhenDeviceAuthorized from 'support/conditionals/WhenDeviceAuthorized'
import WhenDeviceNotAuthorized from 'support/conditionals/WhenDeviceNotAuthorized'
import SetViewportHeight from 'support/utilities/SetViewportHeight'

export default function WithSidebarAndHeader (props) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div onClick={props.onClick} className='h-screen flex overflow-hidden bg-background'>
      <SetViewportHeight />

      <WhenDeviceNotAuthorized>
        {/* Off-canvas menu for small screens */}
        <SidebarMobile isOpen={isOpen} setIsOpen={setIsOpen}>
          {props.sidebar}
        </SidebarMobile>

        {/* Static sidebar for desktop */}
        <SidebarDesktop>
          {props.sidebar}
        </SidebarDesktop>
      </WhenDeviceNotAuthorized>

      <WhenDeviceAuthorized>
        <SidebarTablet>
          {props.sidebar}
        </SidebarTablet>
      </WhenDeviceAuthorized>

      <div className='flex flex-col w-0 flex-1 overflow-hidden'>
        <main className='flex-1 relative z-0 overflow-hidden focus:outline-none' tabIndex='0'>
          <WhenDeviceNotAuthorized>
            {/* Button to open the sidebar */}
            <SidebarOpenButton onClick={() => setIsOpen(!isOpen)} />
          </WhenDeviceNotAuthorized>

          {/* HEADER */}
          {props.header}

          {/* Main Content */}
          {props.children}
        </main>
      </div>
    </div>
  )
}
